import { httpsCallable } from "firebase/functions";
import { functions } from "../../firebase";

export async function calendarCall(method, data = {}) {
  const response = await httpsCallable(functions, `calendar${method}`, { timeout: 540000 })(data);
  return response.data;
}

export const venueToday = () => new Intl.DateTimeFormat("en-CA", { timeZone: "Europe/London", year: "numeric", month: "2-digit", day: "2-digit" }).format(new Date());
export function monthRange(month) {
  const [year, number] = month.split("-").map(Number);
  return { from: `${month}-01`, until: `${month}-${new Date(Date.UTC(year, number, 0)).getUTCDate()}` };
}
export function shiftMonth(month, direction) {
  const [year, number] = month.split("-").map(Number);
  return new Date(Date.UTC(year, number - 1 + direction, 1)).toISOString().slice(0, 7);
}
export function shiftDate(day, days) {
  const value = new Date(`${day}T12:00:00Z`);
  value.setUTCDate(value.getUTCDate() + days);
  return value.toISOString().slice(0, 10);
}
export function weekRange(day) {
  const weekday = new Date(`${day}T12:00:00Z`).getUTCDay();
  const from = shiftDate(day, -((weekday + 6) % 7));
  return { from, until: shiftDate(from, 6) };
}
